import { facetToCheckboxOption } from "../../../../../Functional/converters/facetConverter";
import { IFilterValues, IGetFilterFieldConfig } from "../../../types";
import { getCheckboxGroupComponents } from "./getCheckboxGroupComponents";

export function getCheckboxGroupFilterConfigWithFacets({
  name,
  facetNames,
  values,
  filterDrawerValues,
  setFilterValues,
  setFilterDrawerValues,
  facets,
  modifiers = {},
  t,
  dataTestId,
}: IGetFilterFieldConfig<IFilterValues>) {
  const fieldFacets = (facetNames && facets[facetNames[0]]) || [];
  const fieldOptions = fieldFacets.map(facetToCheckboxOption);

  const { filterControlComponent, filterDrawerConfig, tags } =
    getCheckboxGroupComponents({
      fieldOptions,
      name,
      values,
      filterDrawerValues,
      setFilterValues,
      setFilterDrawerValues,
      dataTestId,
      t,
    });

  return {
    tags,
    filterDrawerConfig,
    filterControlComponent: modifiers?.showFilterControl
      ? filterControlComponent
      : null,
  };
}
